import React from 'react';
import DfbImageCard from './cards/dfb_image_card';
import DfbContentImageCard from './cards/dfb_content_image_card';
import DfbEventCard from './cards/dfb_event_card';
import DfbVideoCard from './cards/dfb_video_card';
import DfbPodcastCard from './cards/dfb_podcast_card';

const DfbCard = (props) => {
  if (['event'].indexOf(props.data.type) !== -1) {
    return (
      <DfbEventCard {...props} variant='bottom' />
    )
  } else if (['video'].indexOf(props.data.type) !== -1) {
    return (
      <DfbVideoCard {...props} />
    )
  } else if (['podcast'].indexOf(props.data.type) !== -1) {
    return (
      <DfbPodcastCard {...props} />
    )
  } else if (['three-questions-to'].indexOf(props.data.type) !== -1) {
    return (
      <DfbContentImageCard {...props} />
    )
  } else {
    return (
      <DfbImageCard {...props} />
    )
  }
}

export default DfbCard;
